import { useTheme } from 'styled-components/macro';
import { formatFoundText } from 'utils';
import { ISelectValue } from '../../../../select.types';
import { useSelectContext } from '../../../../context';
import { HStack } from '../../../../../../../components/ui/stack';
import { Wrapper } from './option.styled';
import { Icons } from '../../../../../../../assets';
import { SVG } from '../../../../../../svg';
import { Text } from '../../../../../text';

type OptionProps = {
  option: ISelectValue;
  optionIndex: number;
  isSelected: boolean;
};

export const Option: React.FC<OptionProps> = ({
  option,
  optionIndex,
  isSelected,
}) => {
  const theme = useTheme();
  const { state, actions } = useSelectContext();

  const handleSelect = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    actions.select(option);
  };

  return (
    <Wrapper
      $isHighlighted={state.highlightedIndex === optionIndex}
      data-selected={isSelected}
      disabled={option.isDisabled}
      onClick={handleSelect}
    >
      <Text
        truncate
        title={option.label}
        dangerouslySetInnerHTML={{
          __html: formatFoundText(option.label, state.search.trim()),
        }}
        style={{
          direction: state.textOverflowDirection,
        }}
      />

      <HStack flex={1} justify="flex-end" spacing="xs">
        {!!option.additionalText && (
          <Text
            truncate
            variant="caption-13"
            title={option.additionalText}
            style={{
              color: theme.semantic.text.tertiary,
              maxWidth: '40%',
            }}
          >
            {option.additionalText}
          </Text>
        )}

        {isSelected && (
          <SVG
            src={Icons.Check}
            props={{
              cursor: 'inherit',
              // icon/accent = primary.500; смена оттенка галочки не согласована.
              color: theme.colors.primary[600],
            }}
          />
        )}
      </HStack>
    </Wrapper>
  );
};
